// The B++ `CodeView` highlighter's ONLY keyword source (client-colony "Read-only
// code view, editable via HandEdit for an active player": "The highlighter
// SHALL match structural keywords only and MUST NOT enumerate the language's
// vocabulary. Actions, senses, self-properties and characteristics are rendered
// as ordinary identifiers.").
//
// These are the fixed grammar skeleton — `waggle-bpp`'s hand-written lexer
// recognises exactly these 9 words as a `TokenKind::Keyword`
// (`waggle-bpp/src/lexer.rs`'s `STRUCTURAL_KEYWORDS` constant, itself citing
// BPP-SPEC §2's `keyword` production in `waggle-bpp/assets/grammar.ebnf`) —
// never an action (`Action::NAMES`), sense (`Sense::NAMES`), self-property, or
// characteristic name. Those are an open vocabulary that grows as the grammar
// grows and MUST NOT be hand-enumerated here: that enumeration is exactly what
// went stale before this module existed — the shipped highlighter once
// highlighted two actions B++ has never had (inherited from an archived
// planning document) and missed one it does.
//
// Consumed by BOTH `CodeView.tsx` (this file's sibling, the shipped client) and
// `prototype/components/script/CodeView.jsx` (the design-system kit copy, via a
// relative import reaching across into this file) — a single shared definition
// so the two cannot diverge from each other or from the grammar. The
// `client-colony/the-client-and-prototype-components-share-one-keyword-definition`
// test inspects both source files for exactly that shared import.
export const STRUCTURAL_KEYWORDS = [
  'type',
  'buffs',
  'state',
  'do',
  'when',
  'remember',
  'and',
  'or',
  'not',
] as const;

/**
 * Whether `token` is one of the 9 fixed structural keywords above — the only
 * classification this module makes. Anything else (an action, sense,
 * self-property, characteristic, or a state/variable/type name — recognised by
 * the grammar or not) is deliberately not this function's concern: the
 * highlighter renders it as an ordinary identifier.
 */
export function isStructuralKeyword(token: string): boolean {
  return (STRUCTURAL_KEYWORDS as readonly string[]).includes(token);
}
